import axios from 'axios';
import { jmapGatewayClient, JMAP_GATEWAY_URL } from './apiClient';
import type { UserPreferences, MfaStatus, MfaSetup, BrandingSettings } from '@/types/api';

export async function updateDisplayName(token: string, displayName: string) {
  return await jmapGatewayClient.patch<{ displayName: string }>(
    '/user/profile',
    token,
    { displayName }
  );
}

export async function getPreferences(token: string) {
  return await jmapGatewayClient.get<UserPreferences>(
    '/user/preferences',
    token
  );
}

export async function updatePreferences(token: string, payload: UserPreferences) {
  return await jmapGatewayClient.patch<UserPreferences>(
    '/user/preferences',
    token,
    payload
  );
}

export async function getMfaStatus(token: string) {
  return await jmapGatewayClient.get<MfaStatus>(
    '/user/mfa/status',
    token
  );
}

export async function startMfaSetup(token: string) {
  return await jmapGatewayClient.post<MfaSetup>(
    '/user/mfa/setup',
    token,
    {}
  );
}

export async function verifyMfa(token: string, code: string) {
  return await jmapGatewayClient.post<{ status: string }>(
    '/user/mfa/verify',
    token,
    { code }
  );
}

export async function disableMfa(token: string) {
  return await jmapGatewayClient.post<void>(
    '/user/mfa/disable',
    token,
    {}
  );
}

export async function getBranding(token: string) {
  console.log('[tenantClient] Fetching branding from /user/branding');
  try {
    const branding = await jmapGatewayClient.get<BrandingSettings>('/user/branding', token);
    console.log('[tenantClient] Branding fetch successful:', branding);
    return branding;
  } catch (error: any) {
    console.error('[tenantClient] Branding fetch failed:', error.response?.status, error.response?.data || error.message);
    throw error;
  }
}

export async function uploadProfileAvatar(token: string, file: File) {
  const formData = new FormData();
  formData.append('file', file);
  const response = await axios.post(`${JMAP_GATEWAY_URL}/user/avatar`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
}

export async function fetchProfileAvatar(token: string): Promise<Blob | null> {
  try {
    const response = await axios.get(`${JMAP_GATEWAY_URL}/user/avatar`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: 'blob',
    });
    return response.data;
  } catch (error: any) {
    if (error?.response?.status === 404) {
      return null;
    }
    throw error;
  }
}

export async function fetchUserAvatarByEmail(token: string, email: string): Promise<Blob | null> {
  try {
    const response = await axios.get(`${JMAP_GATEWAY_URL}/user/avatar`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: { email },
      responseType: 'blob',
    });
    return response.data;
  } catch (error: any) {
    if (error?.response?.status === 404) {
      return null;
    }
    throw error;
  }
}
